/**********360以下のモバイル端末でビューポートを変更する（4インチ端末対応）**********/
let viewport = document.querySelector('meta[name="viewport"]');

function switchViewport() {
  let value =
    window.outerWidth > 360
      ? 'width=device-width,initial-scale=1'
      : 'width=360';
  if (viewport.getAttribute('content') !== value) {
    viewport.setAttribute('content', value);
  }
}

addEventListener('resize', switchViewport, false);
switchViewport();

/*****************iOS Safari判定*******************/
document.addEventListener("DOMContentLoaded", () => {
  const ua = navigator.userAgent.toLowerCase();
  const body = document.body;

  if (/iphone|ipad|ipod/.test(ua)) {
    body.classList.add("ios");

    // iOS バージョンを抽出
    const match = ua.match(/os (\d+)_/);
    if (match && match[1]) {
      body.classList.add(`ios${match[1]}`);
    }

    // iOS Safari 判定
    // Chrome for iOS → "crios" が含まれる
    // Firefox for iOS → "fxios" が含まれる
    // Safariのみ → "safari" を含み、かつ crios/fxios を含まない
    if (/safari/.test(ua) && !/crios|fxios/.test(ua)) {
      body.classList.add("safari");
    }
  }
});

/**********TOPページメインスライダー**********/
// Splide
// https://ja.splidejs.com/
// https://b-risk.jp/blog/2022/07/splide/
// next prev 無効化する場合はCSSで非表示にする
// MV以外のパターンは parts を参照
document.addEventListener("DOMContentLoaded", function () {
  const main_content_slider = document.querySelector(".main_content_slider .splide");
  const main_content_slider_buttons = document.querySelector(".main_content_slider-buttons.splide");

  if (main_content_slider && main_content_slider_buttons) {
    let mv_options = {
      type: "loop",
      perPage: 1,
      pagination: true,
      arrows: false,
      rewind: true,
      autoplay: true,
      interval: 6000,
      speed: 800,
      pauseOnFocus: false,
      padding: 15,
      fixedWidth: 'min(630px, 100%)',
      gap: 20,
      clones: 2,
      heightRatio: 1.25,
      lazyLoad: 'sequential',
      dragMinThreshold: {
        mouse: 10,
        touch: 40, // スマホのスワイプ誤認防止
      }
    };

    let mv_splide = new Splide(main_content_slider, mv_options);

    // サブスライダー（ボタン用）
    let button_options = {
      type: "fade",
      perPage: 1,
      pagination: false,
      arrows: false,
      drag: false,
      speed: 1200, // フェード速度を600→1200msに変更
      rewind: true,
      autoplay: false,
      breakpoints: {
        768: {
          fixedWidth: null,
        }
      }
    };
    let button_splide = new Splide(main_content_slider_buttons, button_options);

    // カスタムフェード（ボタンが一度消えてから次が出る）
    button_splide.on('move', function(newIndex, prevIndex, destIndex) {
      const slides = main_content_slider_buttons.querySelectorAll('.splide__slide');
      slides.forEach(slide => {
        slide.style.transition = 'opacity 0.6s';
        slide.style.opacity = '0';
      });
      setTimeout(() => {
        slides.forEach((slide, idx) => {
          slide.style.opacity = (idx === newIndex) ? '1' : '0';
        });
      }, 600); // 0.6秒後に次のボタンを表示
    });
    // 初期表示
    setTimeout(() => {
      const slides = main_content_slider_buttons.querySelectorAll('.splide__slide');
      slides.forEach((slide, idx) => {
        slide.style.transition = 'opacity 0.6s';
        slide.style.opacity = (idx === 0) ? '1' : '0';
      });
    }, 10);

    // 連動（同期）
    mv_splide.sync(button_splide);
    mv_splide.mount();
    button_splide.mount();
  }
});

/**********TOPお知らせスライダー**********/
document.addEventListener("DOMContentLoaded", function () {
  const topNewsList = document.querySelector(".top_news_list .splide");

  if (!topNewsList) return;

  const slides = topNewsList.querySelectorAll(".splide__slide");
  const multipleSlides = slides.length > 1;

  const options = {
    type: multipleSlides ? "loop" : "slide",
    perPage: 1,
    pagination: false,
    arrows: false,
    rewind: multipleSlides,
    autoplay: false,
    interval: 6000,
    speed: 800,
    pauseOnFocus: true,
    padding: 'calc(50vw - 550px)',
    gap: 10,
    dragMinThreshold: {
      mouse: 10,
      touch: 40, // スマホのスワイプ誤認防止
    },
    breakpoints: {
      1160: {
        padding: '30px',
      }
    },
    ...(multipleSlides && { clones: 2 }) // clones: 2 を条件付きで追加
  };

  new Splide(topNewsList, options).mount();
});

/**********トピックススライダー**********/
document.addEventListener("DOMContentLoaded", function () {
  const main_topics = document.querySelector(".main_topics .splide");

  if (main_topics) {
    let main_topics_options = {
      type: 'slide',
      fixedWidth: 'calc((100% - 20px) / 3)',
      gap: 10,
      pagination: false,
      arrows: false,
      drag: 'free',
      lazyLoad: 'sequential',
      breakpoints: {
        768: {
          fixedWidth: '85%',
        }
      }
    };

    let main_topics_splide = new Splide(main_topics, main_topics_options);
    main_topics_splide.mount();
  }
});

/**********カラーswatchクリックで商品サムネイル画像切替**********/
function bindColorSwatchEvents() {
  const swatches = document.querySelectorAll(".card__product-color-swatch .swatch");
  swatches.forEach((swatch) => {
    if (swatch.classList.contains('event-binded')) return;
    swatch.classList.add('event-binded');
    swatch.addEventListener("click", function () {
      let variantImage = this.getAttribute("data-image");
      let productCard = this.closest(".product-card-wrapper");
      let productImage = productCard.querySelector(".media img");
      if (productImage && variantImage) {
        variantImage = variantImage.startsWith("//") ? "https:" + variantImage : variantImage;
        let highResImage = variantImage.replace(/_(small|medium|large|compact)/, "_1024x1024");
        productImage.src = highResImage;
        productImage.srcset = highResImage;
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", bindColorSwatchEvents);

/**********ドロワーメニュー開閉**********/
const drawer = document.querySelector("#menu-drawer");
const drawerBtn = document.querySelector("#js-header-drawer-open");
const drawerClose = document.querySelector("#js-header-drawer-close");
const drawerBg = document.querySelector("#drawer_backdrop");
//drawerBtnクリックで drawer-openクラスを付与
drawerBtn.addEventListener("click", function () {
  drawer.classList.add("drawer-open");
  // bodyに overflow-hidden クラスを付与
  document.body.classList.add("overflow-hidden");
});
//drawerCloseクリックで drawer-openクラスを削除
drawerClose.addEventListener("click", function () {
  drawer.classList.remove("drawer-open");
  // bodyから overflow-hidden クラスを削除
  document.body.classList.remove("overflow-hidden");
});
//drawerBg クリックで drawer-openクラスを削除
drawerBg.addEventListener("click", function () {
  drawer.classList.remove("drawer-open");
  // bodyから overflow-hidden クラスを削除
  document.body.classList.remove("overflow-hidden");
});

//ドロワーサブメニュー
$(document).ready(function () {
  $(".js-drawer-submenu-toggle").on("click", function () {
    $(this).toggleClass("sub-menu-open");
    $(this).next(".menu-drawer__submenu").slideToggle(300);
  });
});

/**********ヘッダ追従**********/
const header = document.querySelector(".header-wrapper");
const sentinel = document.querySelector("#header-sentinel");

const observer = new IntersectionObserver(
  ([entry]) => {
    if (!entry.isIntersecting) {
      document.body.classList.add("header-fixed");
    } else {
      document.body.classList.remove("header-fixed");
    }
  },
  {
    root: null,
    threshold: 0,
  }
);

observer.observe(sentinel);

(function () {
  /**********TOPページヘッダロゴサイズ変更**********/
  if (document.body.classList.contains('home')) {
    const logo = document.getElementById('home-logo');
    const stickyLogoSection = document.querySelector('.sticky_logo_wrapper');
    const header = document.querySelector('.header-wrapper');
    if (!logo || !stickyLogoSection || !header) return;

    // 文書基準のY座標を取得
    const getDocY = (el) => {
      const r = el.getBoundingClientRect();
      const y = window.scrollY || window.pageYOffset || 0;
      return r.top + y;
    };

    // 画面幅に応じたロゴ幅・係数
    let startWidth, endWidth, scrollFactor, unit;
    let TOP_START, TOP_END;

    function updateSettings() {
      const ww = window.innerWidth;
      if (ww <= 768) {      // Mobile
        startWidth = 44;   // vw
        endWidth = 27;
        scrollFactor = 1.2;
        unit = 'vw';
        TOP_START = 65;  // モバイル用 top の開始値
        TOP_END = 20;  // モバイル用 top の終了値
      } else {              // Desktop
        startWidth = 300;  // px
        endWidth = 150;
        scrollFactor = 1;
        unit = 'px';
        TOP_START = 65;  // PC用 top の開始値
        TOP_END = 20;  // PC用 top の終了値
      }
    }

    function lerp(a, b, t) {
      return a + (b - a) * t;
    }

    // 進行度（0〜1）：ページ先頭(0) → stickyLogoSection の文書基準Yまで
    function getProgress() {
      const y = window.scrollY || window.pageYOffset || 0;

      // 補間を終える位置（“どこまで縮めるか”の終点）
      // ※ offsetTop ではなく文書基準Yを採用（親要素のposition依存を回避）
      const endY = Math.max(getDocY(stickyLogoSection), 1); // 0除算回避

      const raw = y / endY;
      return Math.min(Math.max(raw * scrollFactor, 0), 1);
    }

    let ticking = false;

    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const p = getProgress();
        logo.style.width = lerp(startWidth, endWidth, p) + unit;
        stickyLogoSection.style.top = lerp(TOP_START, TOP_END, p) + 'px';
        ticking = false;
      });
    }

    // 初期化
    updateSettings();
    onScrollOrResize();

    // イベント
    window.addEventListener('scroll', onScrollOrResize, {passive: true});
    window.addEventListener('resize', () => {
      updateSettings();
      onScrollOrResize();
    });
  }

  /***********マイページ都道府県日本語変換*************/
  if ($(".customer.account").length > 0) {
    var prefectures_conversion = {
      Aichi: "愛知県",
      Akita: "秋田県",
      Aomori: "青森県",
      Chiba: "千葉県",
      Ehime: "愛媛県",
      Fukui: "福井県",
      Fukuoka: "福岡県",
      Fukushima: "福島県",
      Gifu: "岐阜県",
      Gunma: "群馬県",
      Hiroshima: "広島県",
      Hokkaido: "北海道",
      Hyogo: "兵庫県",
      Ibaraki: "茨城県",
      Ishikawa: "石川県",
      Iwate: "岩手県",
      Kagawa: "香川県",
      Yamanashi: "山梨県",
      Yamaguchi: "山口県",
      Kochi: "高知県",
      Kumamoto: "熊本県",
      Kyoto: "京都府",
      Mie: "三重県",
      Yamagata: "山形県",
      Miyazaki: "宮崎県",
      Nagano: "長野県",
      Nagasaki: "長崎県",
      Nara: "奈良県",
      Niigata: "新潟県",
      Oita: "大分県",
      Okayama: "岡山県",
      Okinawa: "沖縄県",
      Osaka: "大阪府",
      Saga: "佐賀県",
      Saitama: "埼玉県",
      Shiga: "滋賀県",
      Shimane: "島根県",
      Shizuoka: "静岡県",
      Tochigi: "栃木県",
      Tokushima: "徳島県",
      Tottori: "鳥取県",
      Toyama: "富山県",
      Tokyo: "東京都",
      Miyagi: "宮城県",
      Wakayama: "和歌山県",
      Kanagawa: "神奈川県",
      Kagoshima: "鹿児島県",
    };
    $("#create_customer .prefectures select option").each(function () {
      for (key in prefectures_conversion) {
        if (key == $(this).text()) {
          $(this).text(prefectures_conversion[key]);
        }
      }
    });
  }
})();

/********** タブメニュー (jQuery + ハッシュ制御) **********/
$(document).ready(function () {
  function activateTab($container, target) {
    const $tabButtons = $container.find('.tab__button').filter(function () {
      return $(this).data('tab-target'); // 有効なタブのみ
    });

    const $tabContents = $container.find('.contents__content');

    // ボタン active 切替
    $tabButtons.removeClass('active');
    $tabButtons.filter(`[data-tab-target="${target}"]`).addClass('active');

    // コンテンツ切替（フェード付き）
    $tabContents.each(function () {
      const $content = $(this);
      if ($content.data('tab-content') === target) {
        $content.stop(true, true).addClass('active').fadeIn(200).css('opacity', 1);
      } else {
        $content.stop(true, true).fadeOut(200, function () {
          $content.removeClass('active');
        });
      }
    });
  }

  $('[data-tab-container]').each(function () {
    const $container = $(this);
    const useHash = $container.data('tab-use-hash') === true || $container.data('tab-use-hash') === 'true';
    const $tabButtons = $container.find('.tab__button');

    // タブクリック時の処理
    $tabButtons.on('click', function (e) {
      const $button = $(this);
      const target = $button.data('tab-target');

      if (!target) {
        // タブターゲットがない場合は通常リンクとして動作させる
        return;
      }

      e.preventDefault();

      if (useHash) {
        location.hash = target;
      } else {
        activateTab($container, target);
      }
    });

    // 初期表示処理
    function handleInitialTab() {
      let initialTarget;
      const validButtons = $container.find('.tab__button').filter(function () {
        return $(this).data('tab-target');
      });

      if (useHash) {
        const hash = location.hash.replace('#', '');
        const exists = validButtons.filter(`[data-tab-target="${hash}"]`).length > 0;
        initialTarget = exists
          ? hash
          : validButtons.first().data('tab-target');
      } else {
        initialTarget = validButtons.filter('.active').data('tab-target') ||
                        validButtons.first().data('tab-target');
      }

      if (initialTarget) {
        activateTab($container, initialTarget);
      }
    }

    handleInitialTab();

    if (useHash) {
      $(window).on('hashchange', function () {
        const hash = location.hash.replace('#', '');
        const validButtons = $container.find('.tab__button').filter(function () {
          return $(this).data('tab-target');
        });

        const exists = validButtons.filter(`[data-tab-target="${hash}"]`).length > 0;
        if (exists) {
          activateTab($container, hash);
        }
      });
    }
  });
});

/********** ショッピングガイドアコーディオン **********/
$(document).ready(function () {
  $('.guide-header__top').on('click', function () {
    var $this = $(this);
    var $targetContent = $this.next('.guide-content');

    $('.guide-header__top').not($this).removeClass('active');
    $('.guide-content').not($targetContent).removeClass('active');

    $this.toggleClass('active');
    $targetContent.toggleClass('active');
  });
});
